import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { addRegisteredLayout } from "../layoutDescriptions";
import { Grid, ThemeProvider } from "@material-ui/core";
import { Panel } from "../../../panel";
import { useStyles, actionsTheme } from "./styles";
import { useSubmitErrorSnackbar } from "../../../hooks/useSubmitErrorSnackbar";
import FormStatus from "../../../components/FormStatus";
import clsx from "clsx";
const mainPanelSettings = {
    editableOptions: {
        title: false,
        elevation: true,
        square: true,
        desktopViewForMobile: true
    }
};
const panelSettings = {
    main: mainPanelSettings,
    actions: {}
};
addRegisteredLayout({
    name: "FullWidth",
    displayName: "FullWidth",
    panels: panelSettings,
    canDecideMaxWidth: true,
    canSetBackgroundColor: true
});
export const FullWidth = (props) => {
    const { panels, maxWidth } = props;
    const { main, actions } = panels;
    const classes = useStyles(props);
    useSubmitErrorSnackbar();
    const pageDefinedPanelSpecificProps = {
        maxWidth
    };
    return (_jsxs(Grid, { id: "fullWidthWrapper", container: true, spacing: 3, justifyContent: "center", className: clsx(classes.pageMaxWidth, classes.background), children: [_jsx(Grid, { item: true, xs: 12, md: 12, children: main && _jsx(Panel, { ...pageDefinedPanelSpecificProps, ...main }) }), actions?.sections && (_jsxs(Grid, { item: true, xs: 12, md: 12, children: [_jsx(FormStatus, { className: classes.alignRight, hideStatusMessage: true }), _jsx(ThemeProvider, { theme: actionsTheme, children: _jsx(Panel, { transparent: true, justifyContent: "center", ...pageDefinedPanelSpecificProps, ...actions }) })] }))] }));
};
FullWidth.displayName = "DployFormFullWidth";
//# sourceMappingURL=FullWidth.js.map